<!-- Los filtros se aplican en vivo sobre el mapa: "Aplicar" sólo cierra -->
@if (dialogRef) {
  <mat-card>
    <app-card-header
      [title]="'Filtros'"
      icono="filter_alt"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <mat-card-content class="card-content-crear">
      <ng-container *ngTemplateOutlet="cuerpo"></ng-container>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button
        irxBoton="secundario"
        type="button"
        (click)="limpiarFiltros(); limpiarFiltrosCapas()"
      >
        <mat-icon>filter_alt_off</mat-icon>
        Limpiar
      </button>
      <button
        irxBoton="principal"
        type="button"
        (click)="dialogRef.close()"
      >
        <mat-icon>check</mat-icon>
        Aplicar
      </button>
    </mat-card-actions>
  </mat-card>
} @else {
  <ng-container *ngTemplateOutlet="cuerpo"></ng-container>
}

<ng-template #cuerpo>
  <!-- SECCIÓN CLIENTES (filtro único: aplica a vehículos, ubicaciones y recorridos) -->
  <app-content-card title="Clientes" icon="apartment">
    <section class="inputs-group">
      <app-cliente-selector
        [(ngModel)]="selectedClienteIds"
        (clientesChange)="aplicarFiltrosClientes()"
        [multiple]="true"
        [filterModules]="modulosCliente"
        style="width: 100%"
      ></app-cliente-selector>
    </section>
    <section class="inputs-group">
      <mat-checkbox
        [(ngModel)]="includeChildren"
        (change)="aplicarFiltrosClientes()"
      >
        Incluir jerarquía
      </mat-checkbox>
    </section>

    <div class="fv-resumen">
      <span class="fv-resumen-texto">
        Clientes filtrados:
        <strong>{{ totalClientesSeleccionados }}</strong>
      </span>
      <button
        irxBotonIcono
        type="button"
        tooltip="Volver al cliente actual"
        [class.fv-activo]="totalClientesSeleccionados > 0"
        (click)="limpiarFiltrosClientes()"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
    </div>
  </app-content-card>

  <!-- SECCIÓN VEHÍCULOS -->
  <app-content-card
    [title]="'Vehículos: ' + (vehiculos?.length || 0)"
    icon="directions_car"
  >
    <section class="inputs-group">
      <!-- GRUPOS -->
      <ng-select
        [items]="gruposFiltrados"
        [virtualScroll]="true"
        bindLabel="nombre"
        bindValue="_id"
        placeholder="Flotas"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedGrupoIds"
        (change)="aplicarFiltros()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          <span
            class="color-circle"
            [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
          ></span>
          {{ item?.nombre }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          <span
            class="color-circle"
            [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
          ></span>
          {{ item?.nombre }}
        </ng-template>
      </ng-select>

      <!-- FUNCIONES -->
      <ng-select
        [items]="funcionesDisponibles"
        placeholder="Funciones"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedFunciones"
        (change)="aplicarFiltros()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ getFuncionLabel(item) }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          {{ getFuncionLabel(item) }}
        </ng-template>
      </ng-select>
    </section>

    <section class="inputs-group">
      <!-- TIPOS DE VEHÍCULO -->
      <ng-select
        [items]="tiposVehiculoDisponibles"
        placeholder="Tipos de vehículo"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedTiposVehiculo"
        (change)="aplicarFiltros()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ getTipoLabel(item) }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          {{ getTipoLabel(item) }}
        </ng-template>
      </ng-select>

      <!-- VEHÍCULOS -->
      <ng-select
        [items]="vehiculosFiltrables"
        [virtualScroll]="true"
        bindLabel="identificacion"
        bindValue="_id"
        placeholder="Vehículos"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedVehiculoIds"
        (change)="aplicarFiltros()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item?.identificacion }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          {{ item?.identificacion }}
        </ng-template>
      </ng-select>
    </section>

    <!-- SOLO ENCENDIDOS -->
    <section class="inputs-group">
      <mat-checkbox [(ngModel)]="soloEncendidos" (change)="aplicarFiltros()">
        Sólo encendidos
      </mat-checkbox>
    </section>

    <!-- Acciones y resumen -->
    <div class="fv-resumen">
      <span class="fv-resumen-texto">
        Resultados:
        <strong>{{ vehiculosFiltradosCount }}</strong>
        vehículos
      </span>
      <button
        irxBotonIcono
        type="button"
        [tooltip]="totalFiltrosActivos > 0 ? 'Limpiar filtros' : 'Sin filtros'"
        [class.fv-activo]="totalFiltrosActivos > 0"
        (click)="limpiarFiltros()"
      >
        <mat-icon>
          {{ totalFiltrosActivos > 0 ? 'filter_alt' : 'filter_alt_off' }}
        </mat-icon>
      </button>
    </div>
  </app-content-card>

  <!-- SECCIÓN CAPAS: ubicaciones y recorridos comparten el filtro de clientes -->
  <app-content-card title="Capas del mapa" icon="layers">
    <section class="inputs-group">
      <!-- UBICACIONES -->
      <ng-select
        [items]="ubicacionesFiltrables"
        [virtualScroll]="true"
        bindLabel="identificacion"
        bindValue="_id"
        placeholder="Ubicaciones"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedUbicacionIds"
        (change)="aplicarFiltrosUbicaciones()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item?.identificacion }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          {{ item?.identificacion }}
        </ng-template>
      </ng-select>

      <!-- RECORRIDOS -->
      <ng-select
        [items]="recorridosFiltrables"
        [virtualScroll]="true"
        bindLabel="nombre"
        bindValue="_id"
        placeholder="Recorridos"
        notFoundText="Sin resultados"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        appendTo="body"
        [(ngModel)]="selectedRecorridoIds"
        (change)="aplicarFiltrosRecorridos()"
        class="fv-select"
      >
        <ng-template ng-option-tmp let-item="item">
          <span
            class="color-circle"
            [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
          ></span>
          {{ item?.nombre }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon right"
            role="button"
            tabindex="0"
            aria-label="Quitar"
            (click)="clear(item)"
            (keydown.enter)="clear(item)"
            >×</span
          >
          <span
            class="color-circle"
            [ngStyle]="{ 'background-color': item?.color || '#6b7280' }"
          ></span>
          {{ item?.nombre }}
        </ng-template>
      </ng-select>
    </section>

    <!-- Acciones y resumen de las capas -->
    <div class="fv-resumen">
      <span class="fv-resumen-texto">
        Resultados:
        <strong>{{ ubicacionesFiltradasCount }}</strong>
        ubicaciones ·
        <strong>{{ recorridosFiltradosCount }}</strong>
        recorridos
      </span>
      <button
        irxBotonIcono
        type="button"
        [tooltip]="
          totalFiltrosActivosCapas > 0 ? 'Limpiar filtros' : 'Sin filtros'
        "
        [class.fv-activo]="totalFiltrosActivosCapas > 0"
        (click)="limpiarFiltrosCapas()"
      >
        <mat-icon>
          {{ totalFiltrosActivosCapas > 0 ? 'filter_alt' : 'filter_alt_off' }}
        </mat-icon>
      </button>
    </div>
  </app-content-card>
</ng-template>
